import { Pipe, PipeTransform } from '@angular/core';
import { ArrangementResource, Resource } from '@thiememeulenhoff/types';
import { getResourceNumber } from './get-resource-number';

@Pipe({
  name: 'resourceNumber',
})
export class ResourceNumberPipe implements PipeTransform {
  transform(
    value: Resource | ArrangementResource | undefined | null,
    parent?: Resource | ArrangementResource,
    arrangementResource?: Resource | ArrangementResource,
  ): string {
    if (!value) {
      return '';
    }

    return getResourceNumber(value, parent, arrangementResource);
  }
}
